// Dropdown options for Superhost CRM

export const PROPERTY_STATUS_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'Not Started', label: 'Not Started' },
  { value: 'Active', label: 'Active' },
  { value: 'Inactive', label: 'Inactive' },
  { value: 'In Progress', label: 'In Progress' },
  { value: 'Only Listing', label: 'Only Listing' },
  { value: 'Terminated (Handed Owner)', label: 'Terminated (Handed Owner)' },
  { value: 'Owner Left', label: 'Owner Left' }
];

export const LEAD_STAGE_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'Closed Won', label: 'Closed Won' },
  { value: 'N/A', label: 'N/A' }
];

export const INDIAN_STATES = [
  { value: '', label: 'Select State' },
  { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
  { value: 'Arunachal Pradesh', label: 'Arunachal Pradesh' },
  { value: 'Assam', label: 'Assam' },
  { value: 'Bihar', label: 'Bihar' },
  { value: 'Chhattisgarh', label: 'Chhattisgarh' },
  { value: 'Goa', label: 'Goa' },
  { value: 'Gujarat', label: 'Gujarat' },
  { value: 'Haryana', label: 'Haryana' },
  { value: 'Himachal Pradesh', label: 'Himachal Pradesh' },
  { value: 'Jharkhand', label: 'Jharkhand' },
  { value: 'Karnataka', label: 'Karnataka' },
  { value: 'Kerala', label: 'Kerala' },
  { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
  { value: 'Maharashtra', label: 'Maharashtra' },
  { value: 'Manipur', label: 'Manipur' },
  { value: 'Meghalaya', label: 'Meghalaya' },
  { value: 'Mizoram', label: 'Mizoram' },
  { value: 'Nagaland', label: 'Nagaland' },
  { value: 'Odisha', label: 'Odisha' },
  { value: 'Punjab', label: 'Punjab' },
  { value: 'Rajasthan', label: 'Rajasthan' },
  { value: 'Sikkim', label: 'Sikkim' },
  { value: 'Tamil Nadu', label: 'Tamil Nadu' },
  { value: 'Telangana', label: 'Telangana' },
  { value: 'Tripura', label: 'Tripura' },
  { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
  { value: 'Uttarakhand', label: 'Uttarakhand' },
  { value: 'West Bengal', label: 'West Bengal' },
  // Union Territories
  { value: 'Andaman and Nicobar Islands', label: 'Andaman and Nicobar Islands' },
  { value: 'Chandigarh', label: 'Chandigarh' },
  { value: 'Dadra and Nagar Haveli and Daman and Diu', label: 'Dadra and Nagar Haveli and Daman and Diu' },
  { value: 'Delhi', label: 'Delhi' },
  { value: 'Jammu and Kashmir', label: 'Jammu and Kashmir' },
  { value: 'Ladakh', label: 'Ladakh' },
  { value: 'Lakshadweep', label: 'Lakshadweep' },
  { value: 'Puducherry', label: 'Puducherry' }
];

export const WEBSITE_AVAILABLE_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'Yes', label: 'Yes' },
  { value: 'No', label: 'No' }
];

export const EXISTING_OTA_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'Online', label: 'Online' },
  { value: 'Offline', label: 'Offline' },
  { value: 'Partially Online', label: 'Partially Online' }
];

export const LEAD_SOURCE_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'GRB Data', label: 'GRB Data' },
  { value: 'Incoming Call', label: 'Incoming Call' },
  { value: 'WhatsApp', label: 'WhatsApp' },
  { value: 'Website', label: 'Website' },
  { value: 'Facebook Ad', label: 'Facebook Ad' },
  { value: 'Google Ad', label: 'Google Ad' },
  { value: 'Indiamart', label: 'Indiamart' },
  { value: 'Tradeindia', label: 'Tradeindia' },
  { value: 'Justdial', label: 'Justdial' },
  { value: 'Sulekha', label: 'Sulekha' },
  { value: 'Paper Ad', label: 'Paper Ad' },
  { value: 'Cold Calling', label: 'Cold Calling' },
  { value: 'Reference', label: 'Reference' },
  { value: '__other__', label: 'Other' }
];

export const INTERESTED_PLAN_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'Silver', label: 'Silver' },
  { value: 'Gold', label: 'Gold' },
  { value: 'Platinum', label: 'Platinum' }
];

export const SETUP_PAYMENT_STATUS_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'Pending', label: 'Pending' },
  { value: 'Completed', label: 'Completed' }
];

export const CHECKLIST_STATUS_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'N/A', label: 'N/A' },
  { value: 'Complete', label: 'Complete' },
  { value: 'Received', label: 'Received' },
  { value: 'Not Required', label: 'Not Required' },
  { value: 'Pending', label: 'Pending' }
];

export const OTA_NAME_OPTIONS = [
  { value: '', label: 'Select OTA' },
  { value: 'MMT', label: 'MMT' },
  { value: 'Agoda', label: 'Agoda' },
  { value: 'Expedia', label: 'Expedia' },
  { value: 'Airbnb', label: 'Airbnb' },
  { value: 'Booking_Com', label: 'Booking.com' },
  { value: 'Cleartrip', label: 'Cleartrip' },
  { value: 'EasemyTrip', label: 'EasemyTrip' },
  { value: 'Hyper Guest', label: 'Hyper Guest' },
  { value: 'GRB', label: 'GRB' },
  { value: 'Hotel Beds', label: 'Hotel Beds' },
  { value: 'Hostel World', label: 'Hostel World' },
  { value: 'Trip_com', label: 'Trip.com' },
  { value: 'Rezlive', label: 'Rezlive' },
  { value: 'Priceline', label: 'Priceline' },
  { value: 'Hotels_Com', label: 'Hotels.com' },
  { value: 'Goibibo', label: 'Goibibo' },
  { value: 'Tripadvisor', label: 'Tripadvisor' },
  { value: 'Oyo', label: 'Oyo' },
  { value: 'FabHotels', label: 'FabHotels' },
  { value: 'Treebo', label: 'Treebo' },
  { value: 'Yatra', label: 'Yatra' }
];

export const OTA_STATUS_OPTIONS = [
  { value: '', label: 'Select Status' },
  { value: 'INTEGRATION', label: 'INTEGRATION' },
  { value: 'NOT STARTED', label: 'NOT STARTED' },
  { value: 'PROGRESS', label: 'PROGRESS' },
  { value: 'SENT TO QC', label: 'SENT TO QC' },
  { value: 'COMPLETED', label: 'COMPLETED' },
  // iter285 — "Integrated" marks an OTA whose Hotel Link + Hotel ID are both
  // set. Rendered as a green clickable badge on the Reports Dashboard.
  { value: 'Integrated', label: 'Integrated' }
];

export const ACCESS_TO_HOTEL_OPTIONS = [
  { value: '', label: 'Select' },
  { value: 'Granted', label: 'Granted' },
  { value: 'Not Granted', label: 'Not Granted' }
];

// Helper function to get available OTA options excluding already selected ones
export const getAvailableOTAOptions = (selectedOTAs, currentOTA) => {
  const selectedValues = selectedOTAs
    .filter(ota => ota.ota_name && ota.ota_name !== currentOTA)
    .map(ota => ota.ota_name);
  
  return OTA_NAME_OPTIONS.filter(
    option => option.value === '' || option.value === currentOTA || !selectedValues.includes(option.value)
  );
};

// Default empty OTA item
export const getEmptyOTAItem = () => ({
  ota_name: '',
  ota_status: '',
  hotel_id: '',
  hotel_link: '',
  listing_url: '',
  completion_status: '',
  qc_owner: '',
  access_to_hotel: '',
  property_name_on_ota: '',
  completion_date: ''
});

// Default empty property checklist
export const getEmptyPropertyChecklist = () => ({
  master_form: '',
  noc_agreement: '',
  lease_agreement: '',
  electricity_bill: '',
  pan_card: '',
  aadhar_card: '',
  gst_certificate: '',
  cancelled_check_and_bank_details: '',
  property_photos: '',
  document_collection_status: ''
});

// Max OTA entries
export const MAX_OTA_ENTRIES = 20;
